export const TOGGLE_LOADING = 'user/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'user/TOGGLE_SUCCESS'
export const SET_USER = 'user/SET_USER'
export const SET_ACTIVE_ROLE = 'user/SET_ACTIVE_ROLE'
export const SET_EMPLOYER_COMPANIES = 'user/SET_EMPLOYER_COMPANIES'
export const CLEAR_ERROR_COMPANIES = 'user/CLEAR_ERROR_COMPANIES'
